module.exports = __webpack_public_path__ + "img/optique.d4ff92fc.png";